import { component } from "picoapp";

export default component((node, ctx) => {
  node.addEventListener("submit", handleSubmit);
  return (node) => {
    node.removeEventListener("submit", handleSubmit);
  };

  function handleSubmit(event) {
    event.preventDefault();
    const data = new FormData(event.target);
    fetch("https://formspree.io/f/moqblnrp", {
      method: "post",
      body: data,
      headers: {
        Accept: "application/json",
      },
    })
      .then((response) => {
        if (response.ok) {
          const wrapper = document.querySelector(".js-warranty-form-wrapper");
          const successMsg = document.querySelector(
            ".js-warranty-form-success"
          );
          wrapper.style.display = "none";
          successMsg.style.display = "";
          successMsg.scrollIntoView({
            behavior: "auto",
            block: "center",
            inline: "center",
          });
          event.target.reset();
        } else {
          document.querySelector(".js-warranty-error").innerHTML =
            "There was an error submitting your form. Please try again.";
        }
      })
      .catch((e) => {
        document.querySelector(".js-warranty-error").innerHTML =
          "There was an error submitting your form. Please try again.";
      });
  }
});
